import { SVGProps } from 'react'

export const LogoInspeq = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 394.61 122.92"
    {...props}
  >
    <defs>
      <style>{'.b{fill:#455671;stroke-width:0px;}'}</style>
    </defs>
    <path
      className="b"
      d="M0,64.41V2.89h13.28v48.24C13.28,58.46,7.33,64.41,0,64.41h0Z"
    />
    <path
      className="b"
      d="M23.84,2.89h13.28v5.34c5.68-4.43,12.6-7.04,18.62-7.04,16.68,0,31.44,11.58,31.89,31.55v18.39c0,7.33-5.95,13.28-13.28,13.28h0v-30.76c0-12.49-8.97-19.18-18.61-19.18-10.9,0-18.62,6.7-18.62,19.18v17.48c0,7.33-5.95,13.28-13.28,13.28h0V2.89Z"
    />
    <path
      className="b"
      d="M158.91,47.83c0,17.14-17.14,18.27-31.78,18.27-22.02,0-31.78-8.17-31.78-23.04h0c6.08,0,12.01,2.18,16.42,6.36,3.6,3.4,10.41,3.4,15.36,3.4,7.04,0,16.91-.23,16.91-5.9,0-13.28-48.81,4.09-48.81-26.9,0-9.19,7.15-18.84,29.4-18.84,20.66,0,33.26,9.65,33.26,23.04h-1.51c-5.21,0-10.01-2.31-13.8-5.88-2.71-2.55-8.15-3.88-17.94-3.88-10.78,0-15.1,1.7-15.1,6.13,0,13.05,49.37-1.48,49.37,27.24Z"
    />
    <path
      className="b"
      d="M180.7,4.71h0c0,1.43,1.58,2.31,2.78,1.55,5.06-3.22,10.77-5.07,15.83-5.07,17.03,0,31.89,11.92,31.89,32.46s-14.98,32.46-31.89,32.46c-5.76,0-11.21-1.57-15.88-4.32-1.21-.71-2.74.17-2.74,1.57v57.74c0,1.01-.82,1.82-1.82,1.82h0c-6.33,0-11.45-5.13-11.45-11.45V4.71c0-1.01.82-1.82,1.82-1.82h9.63c1.01,0,1.82.82,1.82,1.82ZM180.7,33.65c0,11.92,7.94,19.18,18.62,19.18,9.65,0,18.62-5.79,18.62-19.18,0-12.49-8.97-19.18-18.62-19.18-10.9,0-18.62,6.7-18.62,19.18Z"
    />
    <path
      className="b"
      d="M297.96,41.14h-46.76c3.06,8.06,11.01,11.69,18.61,11.69,2.9,0,5.69-.53,8.21-1.55,6.07-2.45,12.98-1.32,17.67,3.25h0c-6.24,7.38-15.66,11.58-25.88,11.58-17.03,0-33.14-12.71-33.14-32.46S252.78,1.18,269.81,1.18c36.21,0,28.15,39.95,28.15,39.95ZM285.13,27.86s.91-13.39-15.32-13.39c-8.06,0-16.57,4.65-19.07,13.39h34.39Z"
    />
    <path
      className="b"
      d="M359.87,57.42l-.23-.61s-2.2-5.69-4.44-6.73c-2.46-1.15-6.93.62-6.93.62l-1.48.59c-9.27,4.36-20.33,2.19-26-6.63-5.88-9.15-3.24-21.33,5.91-27.22,9.15-5.88,21.33-3.24,27.22,5.91,1.4,2.17,2.32,4.52,2.78,6.91l.04.22s1.22,5.21,3.99,7.09c2.21,1.5,8.01-.65,8.01-.65l.7-.24c.61-.2,1.23-.35,1.85-.47.46-7.02-1.24-14.24-5.34-20.6-10.16-15.79-31.2-20.36-47-10.2-15.79,10.16-20.36,31.2-10.2,47,10.16,15.79,31.2,20.36,47,10.2,1.75-1.12,3.36-2.38,4.82-3.75-.26-.47-.49-.95-.7-1.44Z"
    />
  </svg>
)
